export const diffRemainDateToGoback = () => {
  const now = new Date();
  const goBackDate = new Date(Date.UTC(2024, 8, 16, 15, 0, 0));

  const diff = goBackDate.getTime() - now.getTime();
  const diffDays = Math.ceil(diff / (1000 * 60 * 60 * 24));
  return diffDays;
};
